import React, { useEffect, useState, useCallback, useRef, useMemo } from 'react'
import Marker from './interfaces/Marker'
import MapPolyline from './components/MapPolyline/MapPolyline'
import { VIEW_MAPS_MARKERS, VIEW_MAPS_POLYLINE } from './view-utils'
import './main.scss'
import { getApiWebKey, setApiMapKey, setExtensionQualifier } from './api/google-integration'
// import FleetTracking from './components/Views/FleetTracking/FleetTracking'
import Fleet from './interfaces/Fleet'
import HardwareInformation from './interfaces/HardwareInformation'
import { themeAwareWidgetDecorator } from './themeAwareWidgetDecorator'
import TripsContext from './contexts/TripsContext'
import FleetTracking from './components/Pages'
import Vehicles from './components/Pages/Vehicles/index'
import { mock, vehicles as vMock } from './mock/entities'
import { CacheFleetTracking } from './controller/CacheFleetTracking'
import { isObjectEmpty } from './utils'
import globalNotification from 'live/services/global-notification'

interface IProps {
    batch: any
    width: number
    options: any
    isLoading: boolean
}

const MARKERS = 0
const FLEET = 1

const Main = themeAwareWidgetDecorator(
    ({ batch, width, options, isLoading, isTimeToUpdate, isFirstLoad }: IProps): JSX.Element => {
        const {
            zoom = 15,
            steps,
            view,
            perspectives,
            btnFilters, // RETROCOMPATIBILIDADE
            btnFiltersOR,
            btnFiltersAND,
            extensionQualifier,
            maxSpeed,
            positionsReportId,
            tripsReportId
        } = options

        setExtensionQualifier(extensionQualifier)
        const [markers, setMarkers] = useState<Marker[]>([])
        const [isLoaded, setLoaded] = useState<boolean>(false)
        const [cacheLoading, setCacheLoading] = useState<boolean>(true)
        const [tripActive, setTripActive] = useState<any>(undefined)
        const [vehicleActive, setVehicleActive] = useState<any>(undefined)
        const [trips, setTrips] = useState<any[]>([])
        const [mapInstance, setMapInstance] = useState<any>(undefined)
        const mapRef = useRef<google.maps.Map>()
        const [centerMap, setCenterMap] = useState<any>(null)
        const [hardwareData, setHardwareData] = useState<any>(undefined)
        const [vehicles, setVehicles] = useState<any[]>(undefined)
        const [vehiclesSearched, setVehiclesSearched] = useState<any>()
        const [appointmentsMap, setAppointmentsMap] = useState<any>({})
        const [itinerariesMap, setItinerariesMap] = useState<any>({})
        const [perspectivesDB, setPerspectivesDB] = useState([])
        const [filterActive, setFilterActive] = useState([])
        const [isNavegateToTrips, setIsNavegateToTrips] = useState<any>()
        const [reverseGeocoding, setReverseGeocoding] = useState({})
        const [markersRef, setMarkersRef] = useState([])
        const [infoWindow, setInfoWindow] = useState()
        const [viewSettings, setViewSettings] = useState({})
        const [tripHoverActive, setTripHoverActive] = useState()
        const [currentVehicleActive, setCurrentVehicleActive] = useState()

        const urlParams= Object.fromEntries(new URLSearchParams(window.location.hash.split("/")[3]))

        const markerHashMap = useMemo(() => new Map(), [])
        const poiMarkerHashMap = useMemo(() => new Map(), [])
        const selectedVehicles = useMemo(() => [], [])

        const onLoadMap = useCallback(map => {
            setMapInstance(map)
            mapRef.current = map
        }, [])

        useEffect(() => {
            getApiWebKey()
                .then(response => {
                    setApiMapKey(response.data)
                    setLoaded(true)
                })
                .catch(error => {
                    setLoaded(true)
                })
        }, [])

        useEffect(() => {
            if (!batch) {
                batch = []
            }

            createMarkers(batch[MARKERS] || ([] as Marker[]))

            const value: any[] = batch[0] || []

            setPerspectivesDB(value[0]?.perspectives)
            setAppointmentsMap(buildAppointmentsMap(batch[1]))
            setItinerariesMap(buildItinerariesMap(batch[2]))
        }, [batch])

        useEffect(() => {
            const cacheFleetTracking = new CacheFleetTracking();
            cacheFleetTracking.observable.subscribe(subscriberCache)

            return () => {
                cacheFleetTracking.observable.unsubscribe(subscriberCache)
            }
        }, [])

        useEffect(() => {
            if (cacheLoading == true && vehicles && hardwareData) {
                setCacheLoading(false)
            }

            navigateToTrips(hardwareData,vehicles)


        }, [vehicles, hardwareData])

        const navigateToTrips = (hardwareData, vehicles) =>{
            if(urlParams.imei && hardwareData && vehicles ){
                const hardware = hardwareData[urlParams.imei]
                const vehicle = vehicles.find(ele=> ele.imei == urlParams.imei)
                if(hardware || vehicle){
                    setIsNavegateToTrips({hardwareData:hardware,vehicle})
                }
            }
        }

        const subscriberCache = ({ vehicles, hardwares }) => {
            if (vehicles) setVehicles(vehicles)
            if (JSON.stringify(hardwares) !== JSON.stringify(hardwareData)) {
                setHardwareData({ ...hardwares });
            }
        }

        const buildAppointmentsMap = (appointments = []) => {
            const map = {}

            appointments.forEach(ele => {
                map[ele.vehicleID] = ele
            })

            return map
        }

        const buildItinerariesMap = (itineraries = []) => {
            const map = {}

            itineraries.forEach(ele => {
                map[ele.vehicleID] = ele
            })

            return map
        }

        const createMarkers = (markers: Marker[], marker?: Marker) => {
            const markersAux = marker ? addMarker(markers, marker) : markers
            setMarkers(markersAux)
        }
        return (
            <TripsContext.Provider
                value={{
                    markerHashMap,
                    poiMarkerHashMap,
                    isTimeToUpdate,
                    isFirstLoad,
                    tripActive,
                    trips,
                    vehicleActive,
                    vehicles,
                    hardwareData,
                    mapRef,
                    centerMap,
                    mapInstance,
                    appointmentsMap,
                    itinerariesMap,
                    vehiclesSearched,
                    filterActive,
                    isNavegateToTrips,
                    reverseGeocoding,
                    markersRef,
                    infoWindow,
                    tripHoverActive,
                    positionsReportId,
                    tripsReportId,
                    selectedVehicles, //TYPE THIS PROPERLY
                    viewSettings,
                    currentVehicleActive,
                    setCurrentVehicleActive,
                    setTripHoverActive,
                    setInfoWindow,
                    setMarkersRef,
                    setReverseGeocoding,
                    setIsNavegateToTrips,
                    setFilterActive,
                    setVehicles,
                    setVehiclesSearched,
                    setMapInstance,
                    onLoadMap,
                    setCenterMap,
                    setTripActive,
                    setTrips,
                    setVehicleActive,
                    setViewSettings
                }}
            >
                <div className="wrapper-widget-gmaps">
                    {isLoaded && (
                        <>
                            {view === VIEW_MAPS_POLYLINE && (
                                <MapPolyline zoom={zoom} steps={steps} width={width} markers={markers} />
                            )}
                            {view === VIEW_MAPS_MARKERS && (
                                <FleetTracking
                                    isLoading={cacheLoading}
                                    restrictedPerspectives={perspectives}
                                    zoom={zoom}
                                    perspectives={perspectivesDB}
                                    btnFiltersOR={btnFiltersOR}
                                    filtersAND={btnFiltersAND}
                                    maxSpeed={maxSpeed}
                                />
                            )}
                        </>
                    )}
                </div>
            </TripsContext.Provider>
        )
    }
)

const addMarker = (markers: Marker[], marker: Marker): Marker[] => {
    const markersAux = [...markers]

    if (marker && marker.lat && marker.lng) {
        marker.id = markers.length
        markersAux.push(marker)
    }

    return markersAux
}

export default React.memo(Main)
